import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { APPLICATION_STATUS, DEFAULT_CANDIDATE_NOTES } from './careersShared';

const NOTE_MAX = 2000;
const INTERNAL_NOTE_MAX = 4000;

/**
 * Move one or more applications to a new status.
 * `statuses` are the allowed targets; `onSubmit` receives the API body.
 */
export default function StatusChangeDialog({ visible, title, statuses, busy, onHide, onSubmit, initialStatus = null }) {
  const [status, setStatus] = useState(initialStatus);
  const [note, setNote] = useState('');
  const [internalNote, setInternalNote] = useState('');
  const [notify, setNotify] = useState(true);

  // Start fresh each time the dialog opens (not on every parent render)
  useEffect(() => {
    if (!visible) return;
    setStatus(initialStatus && statuses.includes(initialStatus) ? initialStatus : null);
    setNote('');
    setInternalNote('');
    setNotify(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, initialStatus]);

  const submit = () => onSubmit({
    status,
    note: note.trim(),
    internal_note: internalNote.trim(),
    notify_candidate: notify,
  });

  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: '34rem', maxWidth: '95vw' }}
      className="careers-dialog"
      modal
      onHide={onHide}
      footer={(
        <div>
          <Button label="Cancel" text severity="secondary" onClick={onHide} disabled={busy} />
          <Button label="Update status" icon="pi pi-check" severity="help" onClick={submit} disabled={!status || busy} loading={busy} />
        </div>
      )}
    >
      <div className="careers-form">
        <div className="mb-3">
          <label htmlFor="status-change-status">New status</label>
          <Dropdown
            inputId="status-change-status"
            value={status}
            options={statuses.map((key) => ({ label: APPLICATION_STATUS[key].label, value: key }))}
            onChange={(e) => setStatus(e.value)}
            placeholder="Choose a status"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="status-change-note">Message to the candidate</label>
          <InputTextarea
            id="status-change-note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={3}
            autoResize
            maxLength={NOTE_MAX}
            placeholder={status ? DEFAULT_CANDIDATE_NOTES[status] : 'Shown on the candidate’s Applied jobs page'}
          />
          <small className="careers-hint">Shown on the portal timeline. Leave empty to use the default text above.</small>
        </div>
        <div className="mb-3">
          <label htmlFor="status-change-internal">Internal note</label>
          <InputTextarea
            id="status-change-internal"
            value={internalNote}
            onChange={(e) => setInternalNote(e.target.value)}
            rows={2}
            autoResize
            maxLength={INTERNAL_NOTE_MAX}
            placeholder="Only the hiring team sees this"
          />
        </div>
        <div className="careers-check">
          <Checkbox inputId="status-change-notify" checked={notify} onChange={(e) => setNotify(e.checked)} />
          <label htmlFor="status-change-notify">Email the candidate about this update</label>
        </div>
      </div>
    </Dialog>
  );
}
